import wowImageFactory from './WowImage';
import fastdom from 'fastdom';
export default function init(contextWindow, services) {
    const elementName = 'wow-image';
    contextWindow = contextWindow || window;
    if (contextWindow.customElements.get(elementName) === undefined) {
        let resizeObserver;
        if (contextWindow.ResizeObserver) {
            resizeObserver = new contextWindow.ResizeObserver((entries) => entries.map((entry) => entry.target.reLayout()));
        }
        let intersectionObserver;
        if (contextWindow.IntersectionObserver) {
            intersectionObserver = new IntersectionObserver((entries) => entries.map((entry) => {
                if (entry.isIntersecting) {
                    const wowImage = entry.target;
                    wowImage.unobserveIntersect();
                    // resize Observe will invoke relayout imidiatly.
                    // "Observation will fire when observation starts if Element is being rendered, and Element’s size is not 0,0,"
                    // https://drafts.csswg.org/resize-observer/#dom-resizeobserver-observe
                    wowImage.observeResize();
                }
                return entry;
            }), {
                /**
                 * old: 50% from 1080 (desktop) is 540px, 800 (mobile) 400px
                 * new: 150% from 1080 (desktop) is 1620, 800 (mobile) 1200
                 * chrome [loading=lazy]: 4g - 1250px, lower then 3g - 2500px
                 * @see https://web.dev/articles/browser-level-image-lazy-loading#improved-thresholds
                 */
                rootMargin: '150% 100%',
            });
        }
        return function (env) {
            const WowImage = wowImageFactory({
                resizeService: resizeObserver,
                intersectionService: intersectionObserver,
                mutationService: fastdom,
                ...services,
            }, env, contextWindow);
            contextWindow.customElements.define(elementName, WowImage);
        };
    }
    return;
}
//# sourceMappingURL=registry.js.map